import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import EmailOnboardingModal from './components/EmailOnboardingModal'
import OwnerShell from './components/m1nt/OwnerShell'
import Home from './pages/Home'
import OwnerDashboard from './pages/OwnerDashboard'
import GraderDashboard from './pages/GraderDashboard'
import CardDetail from './pages/CardDetail'
import Profile from './pages/Profile'
import DownloadApp from './pages/DownloadApp'
import GraderInspection from './pages/GraderInspection'

function App() {
  return (
    <BrowserRouter>
      <OwnerShell>
        <EmailOnboardingModal />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/owner" element={<OwnerDashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/download" element={<DownloadApp />} />
          <Route path="/grader" element={<GraderDashboard />} />
          <Route path="/grader/inspect/:id" element={<GraderInspection />} />
          {/* Legacy route — the in-app Lab dashboard moved to the separate frontend-lab/ app. Redirect bookmarks to home. */}
          <Route path="/lab" element={<Navigate to="/" replace />} />
          <Route path="/card/:id" element={<CardDetail />} />
        </Routes>
      </OwnerShell>
    </BrowserRouter>
  )
}

export default App
